module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-transfer', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.group_loading),
      expression: "group_loading"
    }],
    ref: "selected_group",
    class: ['omnis-transfer', {
      'header-is-disabled': _vm.header_check_disabled
    }],
    attrs: {
      "titles": ['未选用户组', '已选用户组'],
      "filterable": "",
      "filter-method": _vm.filterMethod,
      "filter-placeholder": "请输入用户组名",
      "props": {
        key: 'user_group_id',
        label: 'user_group_name'
      },
      "data": _vm.user_group_all
    },
    model: {
      value: (_vm.user_group_selected),
      callback: function($$v) {
        _vm.user_group_selected = $$v
      },
      expression: "user_group_selected"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-39a4e761","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/omnis-business/user-group-transfer/user-group-transfer.vue
// module id = eaYr
// module chunks = 81